import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ExplicitIcon(props: IconProps) {
    return <Icon {...props} iconKey={"explicit"}/>
}
